module.exports = __webpack_public_path__ + "img/venda-mais-dashboard-lojista.c03583ce.png";